// src/telemetry.js
// Fire-and-forget analytics beacon for menu selections, tutorial progress,
// and game completions. Falls back gracefully if the backend is unreachable.

const SESSION_KEY = 'phutball_telemetry_session';

function getBaseUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const isProduction = window.location.protocol === 'https:';
  return isProduction
    ? `${window.location.protocol}//${window.location.host}`
    : `http://${window.location.hostname}:8000`;
}

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) ||
           `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Send a telemetry event. Non-blocking; failures are swallowed.
 * @param {string} eventType - 'menu_event' | 'tutorial_progress' | 'game_complete'
 * @param {object} payload - Event-specific payload (no PII, no move data)
 */
export function trackEvent(eventType, payload = {}) {
  const body = JSON.stringify({
    event_type: eventType,
    session_id: getSessionId(),
    payload,
  });

  const url = `${getBaseUrl()}/telemetry/event`;

  // Prefer sendBeacon — survives page unload for end-of-game events
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    }
  } catch { /* fall through */ }

  // Fallback: fire-and-forget fetch
  try {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => { /* swallow */ });
  } catch { /* swallow */ }
}
